import React from "react";
import classNames from "classnames";
import { getColorIcon } from "./getColorIcon";

export type ColorVariantType =
    | "light"
    | "grayLight"
    | "darkBLue"
    | "greenLight"
    | "blue"
    | "orange"
    | "jaguar";

interface Icon {
    visible?: boolean;
    type: string;
    inheritColor?: boolean;
    inheritSize?: boolean;
    className?: string;
    width?: number;
    height?: number;
    colorVariant?: ColorVariantType;
}

const Icon: React.FC<Icon> = ({
    visible,
    type,
    inheritColor,
    inheritSize,
    className,
    width,
    height,
    colorVariant,
}) => {
    const color = getColorIcon(colorVariant);

    if (!visible) {
        return null;
    }

    if (type === `pdf`) {
        return (
            <svg
                fill="none"
                viewBox="0 0 15 20"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="m8.4375 7h5.1563l-5.1563-5.5v5.5zm-6.5625-7h7.5l5.625 6v12c0 0.5304-0.1975 1.0391-0.5492 1.4142-0.3516 0.3751-0.8285 0.5858-1.3258 0.5858h-11.25c-1.0406 0-1.875-0.9-1.875-2v-16c0-0.53043 0.19754-1.0391 0.54918-1.4142 0.35163-0.37507 0.82854-0.58579 1.3258-0.58579zm4.6219 10.44c0.38437 0.9 0.87187 1.64 1.4344 2.15l0.38437 0.32c-0.81562 0.16-1.9406 0.44-3.1312 0.93l-0.10312 0.04 0.46875-1.04c0.42188-0.87 0.73125-1.66 0.94688-2.4zm6.075 3.81c0.1687-0.18 0.2531-0.41 0.2625-0.66 0.0281-0.2-0.0188-0.39-0.1125-0.55-0.2719-0.47-0.975-0.69-2.1375-0.69l-1.2094 0.07-0.81562-0.58c-0.59063-0.52-1.125-1.43-1.5-2.56l0.0375-0.14c0.30938-1.33 0.60001-2.94-0.01874-3.6-0.15-0.16-0.35626-0.24-0.57188-0.24h-0.225c-0.34688 0-0.65625 0.39-0.74063 0.77-0.34687 1.33-0.14062 2.06 0.20626 3.27v0.01c-0.23438 0.88-0.53438 1.9-1.0125 2.93l-0.9 1.8-0.83438 0.49c-1.125 0.75-1.6594 1.59-1.7625 2.12-0.0375 0.19-0.01875 0.36 0.04687 0.54l0.02813 0.05 0.45 0.31 0.4125 0.11c0.75938 0 1.6219-0.95 2.7844-3.07l0.16876-0.07c0.96562-0.33 2.1656-0.56 3.7781-0.75 0.96562 0.51 2.1 0.74 2.8126 0.74 0.4124 0 0.6937-0.11 0.8531-0.3zm-0.3844-0.71l0.0844 0.11c-0.0094 0.1-0.0375 0.11-0.0844 0.13h-0.0375l-0.1781 0.02c-0.4313 0-1.0969-0.19-1.7813-0.51 0.0844-0.1 0.1219-0.1 0.2157-0.1 1.3125 0 1.6874 0.25 1.7812 0.35zm-8.5969 1.46c-0.60937 1.19-1.1625 1.85-1.5844 2 0.04687-0.38 0.46875-1.04 1.1344-1.69l0.44999-0.31zm2.8313-6.91c-0.21563-0.9-0.22501-1.63-0.06563-2.05l0.06563-0.12 0.14062 0.05c0.15938 0.24 0.17813 0.56 0.08438 1.1l-0.02813 0.16-0.15 0.82-0.04687 0.04z"
                    fill="#E03838"
                />
            </svg>
        );
    }

    if (type === `mouse-action`) {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
                <path d="M40 41.007v17.986C40 64.522 44.476 69 50 69c5.523 0 10-4.48 10-10.007V41.007C60 35.478 55.524 31 50 31c-5.523 0-10 4.48-10 10.007zm-2 0C38 34.376 43.371 29 50 29c6.627 0 12 5.373 12 12.007v17.986C62 65.624 56.629 71 50 71c-6.627 0-12-5.373-12-12.007V41.007z" />
                <path d="M49 36v4a1 1 0 002 0v-4a1 1 0 00-2 0z" />
                <path
                    d="M50 81.993l5.5-5.5a1 1 0 011.414 1.414l-6.207 6.207a.997.997 0 01-1.414 0l-6.255-6.254a1 1 0 011.415-1.414L50 81.993z"
                    className="MouseScroll--chevron"
                />
            </svg>
        );
    }

    if (type === "clip") {
        return (
            <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M18.363 10.587C18.688 10.262 18.9458 9.87612 19.1217 9.45146C19.2976 9.02679 19.3882 8.57165 19.3882 8.112C19.3882 7.65235 19.2976 7.1972 19.1217 6.77253C18.9458 6.34787 18.688 5.96202 18.363 5.637C18.038 5.31197 17.6521 5.05415 17.2275 4.87825C16.8028 4.70235 16.3477 4.61182 15.888 4.61182C15.4284 4.61182 14.9732 4.70235 14.5485 4.87825C14.1239 5.05415 13.738 5.31197 13.413 5.637L5.635 13.415C4.97859 14.0714 4.60983 14.9617 4.60983 15.89C4.60983 16.8183 4.97859 17.7086 5.635 18.365C5.96003 18.69 6.34588 18.9478 6.77055 19.1237C7.19521 19.2996 7.65036 19.3902 8.11001 19.3902C9.03831 19.3902 9.92859 19.0214 10.585 18.365L14.651 14.299C14.7671 14.1829 14.8592 14.0451 14.922 13.8934C14.9848 13.7417 15.0172 13.5792 15.0172 13.415C15.0172 13.2508 14.9848 13.0883 14.922 12.9366C14.8592 12.7849 14.7671 12.6471 14.651 12.531C14.5349 12.4149 14.3971 12.3228 14.2454 12.26C14.0937 12.1972 13.9312 12.1648 13.767 12.1648C13.6028 12.1648 13.4403 12.1972 13.2886 12.26C13.1369 12.3228 12.9991 12.4149 12.883 12.531L9.17101 16.244C8.98336 16.4316 8.72887 16.5371 8.46351 16.5371C8.19814 16.5371 7.94365 16.4316 7.75601 16.244C7.56837 16.0564 7.46295 15.8019 7.46295 15.5365C7.46295 15.2711 7.56837 15.0166 7.75601 14.829L11.469 11.117C12.0804 10.5168 12.904 10.1822 13.7608 10.1861C14.6176 10.1901 15.4381 10.5322 16.044 11.138C16.6498 11.7439 16.9919 12.5644 16.9959 13.4212C16.9998 14.278 16.6652 15.1016 16.065 15.713L11.999 19.779C11.4895 20.2953 10.883 20.7058 10.2142 20.9867C9.54546 21.2677 8.82774 21.4136 8.10237 21.416C7.37701 21.4185 6.65832 21.2774 5.9877 21.0009C5.31708 20.7244 4.70777 20.3181 4.19486 19.8051C3.68194 19.2922 3.27555 18.6829 2.99909 18.0123C2.72263 17.3417 2.58155 16.623 2.58398 15.8976C2.58641 15.1723 2.7323 14.4545 3.01325 13.7858C3.2942 13.117 3.70466 12.5105 4.221 12.001L11.999 4.223C12.5085 3.70666 13.115 3.29619 13.7838 3.01524C14.4525 2.73429 15.1703 2.5884 15.8956 2.58597C16.621 2.58354 17.3397 2.72462 18.0103 3.00108C18.6809 3.27755 19.2902 3.68394 19.8031 4.19685C20.3161 4.70976 20.7225 5.31907 20.9989 5.98969C21.2754 6.66031 21.4165 7.379 21.414 8.10436C21.4116 8.82973 21.2657 9.54745 20.9848 10.2162C20.7038 10.885 20.2933 11.4915 19.777 12.001L19.424 12.354C19.3318 12.4496 19.2215 12.5258 19.0996 12.5783C18.9776 12.6308 18.8464 12.6585 18.7136 12.6597C18.5808 12.661 18.4492 12.6358 18.3262 12.5856C18.2033 12.5354 18.0916 12.4612 17.9976 12.3674C17.9037 12.2736 17.8293 12.162 17.779 12.0391C17.7286 11.9162 17.7032 11.7846 17.7043 11.6518C17.7053 11.519 17.7328 11.3878 17.7851 11.2657C17.8375 11.1437 17.9136 11.0333 18.009 10.941L18.363 10.587Z"
                    fill="#23232A"
                />
            </svg>
        );
    }

    if (type === "share") {
        return (
            <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M18.1145 14.2221C17.4851 14.2226 16.8653 14.3764 16.3086 14.6702C15.7519 14.9641 15.275 15.3891 14.919 15.9086L9.50101 13.4596C9.88583 12.5294 9.88732 11.4845 9.50517 10.5531L14.9156 8.09156C15.4432 8.85548 16.2269 9.40479 17.1244 9.63985C18.0219 9.8749 18.9739 9.78014 19.8076 9.37274C20.6413 8.96534 21.3016 8.27229 21.6686 7.41931C22.0356 6.56633 22.0851 5.60991 21.808 4.72354C21.531 3.83717 20.9458 3.07956 20.1586 2.58814C19.3713 2.09671 18.4342 1.90402 17.5173 2.04502C16.6003 2.18601 15.7642 2.65136 15.1605 3.35664C14.5569 4.06192 14.2258 4.96042 14.2273 5.88917C14.2308 6.10899 14.2531 6.32811 14.2938 6.54414L8.54211 9.16067C7.9897 8.64254 7.29813 8.29724 6.55237 8.16719C5.80662 8.03713 5.03916 8.12798 4.34427 8.42859C3.64939 8.72919 3.05734 9.22644 2.64088 9.85927C2.22442 10.4921 2.00167 11.2329 2.00001 11.9907C1.99835 12.7485 2.21784 13.4903 2.63152 14.125C3.0452 14.7596 3.63505 15.2595 4.32861 15.5631C5.02217 15.8668 5.78923 15.961 6.53555 15.8343C7.28187 15.7075 7.97494 15.3652 8.52963 14.8495L14.2963 17.4561C14.2563 17.6719 14.2343 17.8907 14.2306 18.1102C14.2304 18.8794 14.4581 19.6314 14.8849 20.2711C15.3117 20.9108 15.9184 21.4094 16.6283 21.7038C17.3382 21.9983 18.1193 22.0753 18.873 21.9253C19.6266 21.7753 20.3189 21.4049 20.8622 20.8609C21.4055 20.317 21.7755 19.624 21.9254 18.8695C22.0753 18.1151 21.9983 17.3331 21.7041 16.6224C21.41 15.9118 20.912 15.3044 20.273 14.8771C19.634 14.4499 18.8829 14.2219 18.1145 14.2221ZM18.1145 3.66679C18.5536 3.66662 18.9828 3.79682 19.348 4.04092C19.7132 4.28502 19.9979 4.63205 20.166 5.03812C20.3342 5.4442 20.3783 5.89107 20.2927 6.32223C20.2071 6.75338 19.9958 7.14945 19.6853 7.46034C19.3749 7.77123 18.9793 7.98297 18.5487 8.06879C18.118 8.15461 17.6716 8.11065 17.2659 7.94247C16.8603 7.77428 16.5135 7.48944 16.2695 7.12395C16.0256 6.75846 15.8953 6.32875 15.8953 5.88917C15.8958 5.30004 16.1297 4.73515 16.5457 4.31849C16.9618 3.90183 17.526 3.66745 18.1145 3.66679ZM5.9068 14.2221C5.4677 14.2222 5.03842 14.092 4.67324 13.8479C4.30806 13.6038 4.02339 13.2568 3.85524 12.8507C3.68709 12.4447 3.64301 11.9978 3.72857 11.5666C3.81414 11.1355 4.0255 10.7394 4.33593 10.4285C4.64637 10.1176 5.04192 9.90588 5.47257 9.82007C5.90322 9.73425 6.34963 9.77821 6.75532 9.94639C7.16101 10.1146 7.50777 10.3994 7.75174 10.7649C7.9957 11.1304 8.12592 11.5601 8.12592 11.9997C8.12526 12.5888 7.89128 13.1535 7.47528 13.5701C7.05928 13.9867 6.49522 14.2212 5.9068 14.2221ZM18.1145 20.3326C17.6754 20.3326 17.2462 20.2022 16.8811 19.958C16.516 19.7138 16.2315 19.3668 16.0635 18.9607C15.8955 18.5546 15.8515 18.1077 15.9372 17.6766C16.0228 17.2455 16.2342 16.8495 16.5447 16.5387C16.8552 16.2279 17.2507 16.0163 17.6814 15.9305C18.112 15.8448 18.5584 15.8888 18.964 16.057C19.3696 16.2252 19.7164 16.51 19.9603 16.8755C20.2042 17.241 20.3344 17.6707 20.3344 18.1102C20.334 18.6995 20.0999 19.2645 19.6837 19.6812C19.2675 20.0979 18.7031 20.3321 18.1145 20.3326Z"
                    fill="#23232A"
                />
            </svg>
        );
    }

    if (type === "favorite") {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
            >
                <path
                    d="M8 2.7213C9.46833 1.49065 11.1167 1.31767 12.4834 1.96349C13.9834 2.6724 15 4.30444 15 6.16173C14.9999 7.97104 14.2676 9.34922 13.3281 10.443C12.5811 11.3126 11.6704 12.0366 10.8926 12.6559C10.7153 12.797 10.5445 12.9323 10.3828 13.0641C10.0683 13.3204 9.70961 13.6117 9.34082 13.8346C8.97238 14.0572 8.51565 14.2613 8 14.2613C7.48448 14.2613 7.02852 14.0571 6.66016 13.8346C6.29123 13.6117 5.93183 13.3205 5.61719 13.0641C5.45564 12.9324 5.28551 12.7969 5.1084 12.6559C4.33054 12.0366 3.41989 11.3126 2.67285 10.443C1.73335 9.34919 1.00007 7.97113 1 6.16173C1.00004 4.30461 2.01686 2.6725 3.5166 1.96349C4.88315 1.31767 6.53172 1.49091 8 2.7213ZM11.8115 3.44103C10.9616 3.03954 9.77156 3.1107 8.58008 4.39025C8.43068 4.55072 8.22094 4.64415 8 4.64415C7.77919 4.64406 7.57022 4.55064 7.4209 4.39025C6.22919 3.11036 5.03847 3.03933 4.18848 3.44103C3.28535 3.86798 2.59769 4.90151 2.59766 6.16173C2.59772 7.47009 3.11142 8.48186 3.87402 9.36974C4.50895 10.1089 5.28146 10.7259 6.06348 11.3492C6.24772 11.4961 6.43322 11.6433 6.61523 11.7916C6.94487 12.0603 7.21767 12.279 7.47461 12.4342C7.73182 12.5895 7.8956 12.6333 8 12.6334C8.10442 12.6334 8.26875 12.5898 8.52637 12.4342C8.7833 12.279 9.05611 12.0603 9.38574 11.7916C9.56776 11.6433 9.75326 11.4961 9.9375 11.3492C10.7195 10.7259 11.492 10.1089 12.127 9.36974C12.8895 8.48189 13.4033 7.47001 13.4033 6.16173C13.4033 4.90143 12.7147 3.86793 11.8115 3.44103Z"
                    fill="#32BD8B"
                />
            </svg>
        );
    }

    if (type === "back") {
        return (
            <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                className={className}
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"
                    fill="currentColor"
                />
            </svg>
        );
    }

    if (type === "hh") {
        return (
            <svg
                width={width || 24}
                height={height || 24}
                viewBox="0 0 24 24"
                fill="currentColor"
                className={classNames(
                    {
                        icon: true,
                        "inherit-color": !!inheritColor,
                        "inherit-size": !!inheritSize,
                    },
                    className
                )}
            >
                <path d="M6 7V17H8V13H11V17H13V7H11V11H8V7H6Z" />
                <path d="M15 7V17H17V13H20V17H22V7H20V11H17V7H15Z" />
                <path d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z" />
            </svg>
        );
    }

    if (type === "vk") {
        return (
            <svg
                width={width || 24}
                height={height || 24}
                viewBox="0 0 24 24"
                fill="currentColor"
                className={classNames(
                    {
                        icon: true,
                        "inherit-color": !!inheritColor,
                        "inherit-size": !!inheritSize,
                    },
                    className
                )}
            >
                <path d="M15.07 2H8.93C3.33 2 2 3.33 2 8.93v6.14C2 20.67 3.33 22 8.93 22h6.14c5.6 0 6.93-1.33 6.93-6.93V8.93C22 3.33 20.67 2 15.07 2zm3.77 14.39c-.24.66-.77 1.19-1.43 1.43-1.11.37-2.22.55-3.34.55-1.11 0-2.22-.18-3.34-.55-.66-.24-1.19-.77-1.43-1.43-.37-1.11-.55-2.22-.55-3.34s.18-2.22.55-3.34c.24-.66.77-1.19 1.43-1.43 1.11-.37 2.22-.55 3.34-.55s2.22.18 3.34.55c.66.24 1.19.77 1.43 1.43.37 1.11.55 2.22.55 3.34s-.18 2.22-.55 3.34z" />
                <path d="M12 8.5c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5 3.5-1.57 3.5-3.5-1.57-3.5-3.5-3.5z" />
            </svg>
        );
    }

    if (type === "telegram") {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="28"
                height="28"
                viewBox="0 0 28 28"
                fill="none"
            >
                <g clipPath="url(#clip0_7247_399)">
                    <path
                        d="M14 28C21.732 28 28 21.732 28 14C28 6.26801 21.732 0 14 0C6.26801 0 0 6.26801 0 14C0 21.732 6.26801 28 14 28Z"
                        fill="#229ED9"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M6.33719 13.8522C10.4185 12.074 13.14 10.9018 14.5017 10.3354C18.3896 8.71827 19.1975 8.43735 19.7241 8.42808C19.8399 8.42604 20.0988 8.45474 20.2666 8.59085C20.4082 8.70577 20.4472 8.86102 20.4658 8.96998C20.4845 9.07895 20.5077 9.32717 20.4892 9.52112C20.2785 11.7348 19.3669 17.107 18.9031 19.5864C18.7068 20.6355 18.3204 20.9873 17.9463 21.0217C17.1333 21.0965 16.516 20.4844 15.7285 19.9683C14.4963 19.1606 13.8002 18.6578 12.6042 17.8696C11.222 16.9587 12.118 16.4581 12.9057 15.6399C13.1119 15.4258 16.694 12.1676 16.7633 11.872C16.772 11.835 16.7801 11.6972 16.6982 11.6245C16.6163 11.5517 16.4955 11.5766 16.4083 11.5964C16.2848 11.6244 14.3163 12.9255 10.5031 15.4996C9.94433 15.8832 9.43825 16.0702 8.98482 16.0604C8.48494 16.0496 7.52339 15.7777 6.80857 15.5454C5.93182 15.2604 5.235 15.1097 5.29568 14.6257C5.32728 14.3736 5.67445 14.1157 6.33719 13.8522Z"
                        fill="white"
                    />
                </g>
                <defs>
                    <linearGradient
                        id="paint0_linear_7247_399"
                        x1="1400"
                        y1="0"
                        x2="1400"
                        y2="2779.23"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#2AABEE" />
                        <stop offset="1" stopColor="#229ED9" />
                    </linearGradient>
                    <clipPath id="clip0_7247_399">
                        <rect width="28" height="28" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        );
    }

    if (type === "facebook" || type === "facebook-all") {
        return (
            <svg
                width={width || 28}
                height={height || 28}
                viewBox="0 0 28 28"
                fill="none"
                className={classNames(
                    {
                        icon: true,
                        "inherit-color": !!inheritColor,
                        "inherit-size": !!inheritSize,
                    },
                    className
                )}
            >
                <path
                    d="M28 14C28 6.2664 21.7336 0 14 0C6.2664 0 0 6.2664 0 14C0 20.5632 4.5192 26.0736 10.6176 27.5856V18.2784H7.728V14H10.6176V12.1576C10.6176 7.392 12.7736 5.1856 17.4496 5.1856C18.3344 5.1856 19.8688 5.3592 20.4904 5.5328V9.408C20.16 9.3744 19.5888 9.3576 18.872 9.3576C16.576 9.3576 15.6912 10.2256 15.6912 12.488V14H20.2664L19.4824 18.2784H15.6968V27.8992C22.6296 27.0592 28 21.1568 28 14Z"
                    fill="#0866FF"
                />
            </svg>
        );
    }

    if (type === "briefcase") {
        return (
            <svg
                width={width || 24}
                height={height || 24}
                viewBox="0 0 24 24"
                fill="currentColor"
                className={classNames(
                    {
                        icon: true,
                        "inherit-color": !!inheritColor,
                        "inherit-size": !!inheritSize,
                    },
                    className
                )}
            >
                <path d="M20 6h-4V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-6 0h-4V4h4v2z" />
            </svg>
        );
    }

    return (
        <svg
            color={color}
            width={width}
            height={height}
            className={classNames(
                {
                    icon: true,
                    "inherit-color": !!inheritColor,
                    "inherit-size": !!inheritSize,
                },
                className
            )}
        >
            <use
                xmlnsXlink="http://www.w3.org/1999/xlink"
                xlinkHref={`#icon-${type}`}
            />
        </svg>
    );
};

Icon.defaultProps = {
    visible: true,
};

export default Icon;
